export default __webpack_public_path__ + "static/media/08.01.25 Minutes Spcl Mtg.bccee15c.pdf";